import { visibleControlPoint } from "./controlAnchorPoint";

/** Centers the real symbol in its nearest scrollable plan without moving outer controls or changing zoom. */
export function centerDrawingAnchor(element: Element, onlyIfOutside = false): void {
  if (!element.isConnected) return;
  const view = element.ownerDocument.defaultView;
  if (!view) return;
  if (onlyIfOutside) {
    // Routes can pin their anchor to a viewport edge; inspect the real symbol instead.
    const visible = visibleControlPoint(element, {scrollBehavior: "pin-both", edgeInset: 0});
    if (!visible) return;
    const symbol = element.getBoundingClientRect();
    const x = (symbol.left + symbol.right) / 2, y = (symbol.top + symbol.bottom) / 2;
    if (Math.abs(visible.clientX - x) < 0.5 && Math.abs(visible.clientY - y) < 0.5) return;
  }
  for (let parent = element.parentElement; parent; parent = parent.parentElement) {
    const style = view.getComputedStyle(parent);
    const scrollX = /auto|scroll/.test(style.overflowX);
    const scrollY = /auto|scroll/.test(style.overflowY);
    if ((!scrollX && !scrollY) || !parent.offsetWidth || !parent.offsetHeight) continue;
    const symbol = element.getBoundingClientRect();
    const viewport = parent.getBoundingClientRect();
    const scaleX = viewport.width / parent.offsetWidth;
    const scaleY = viewport.height / parent.offsetHeight;
    if (!scaleX || !scaleY) return;
    parent.scrollBy({
      left: scrollX ? ((symbol.left + symbol.right) / 2 - viewport.left) / scaleX - parent.clientLeft - parent.clientWidth / 2 : 0,
      top: scrollY ? ((symbol.top + symbol.bottom) / 2 - viewport.top) / scaleY - parent.clientTop - parent.clientHeight / 2 : 0,
      behavior: "smooth",
    });
    return;
  }
}
